// ******************** LAST EDIT - 9/28/20 ************************************

import LayerList = require("esri/widgets/LayerList");
import {subclass} from "esri/core/accessorSupport/decorators";
import {tsx} from "esri/widgets/support/widget";
// @ts-ignore
import {findSelectedItem} from "esri/widgets/LayerList/support/layerListUtils";

const SORT_FILTER_DATA_ATTR = "data-sort-filter";
const SORT_DATA_ATTR = "data-layer-uid";
//const SORT_DATASET_ID = "layerUid";
const SORTABLE_ROOT = "root";

const CSS = {
  item: "esri-layer-list__item",
  itemContent: "esri-layer-list__item-content",
  itemError: "esri-layer-list__item--error",
  itemInvisible: "esri-layer-list__item--invisible",
  itemInvisibleAtScale: "esri-layer-list__item--invisible-at-scale",
  itemUpdating: "esri-layer-list__item--updating",
  itemChildren: "esri-layer-list__item--has-children",
  itemSelectable: "esri-layer-list__item--selectable",
  itemContainer: "esri-layer-list__item-container",
};

@subclass("app.map.CustomLayerList")
export default class CustomLayerList extends LayerList {

  protected renderItem(item, parent) {

    /* Indoors *********************** */
    let xtnInvisible = false;
    if (this.view && this.view.type === "2d") {
      if (item && item.layer) {
        //console.log("********",item.layer.title,item.layer.definitionExpression);
        if (item.layer.definitionExpression === "1=2") {
          xtnInvisible = true;
        }
      }
    }
    /* ******************************* */

    // @ts-ignore
    const { _newUI, id, selectionEnabled, selectedItems, visibleElements } = this;
    const { children } = item;

    const uid = `${id}_${item.uid}`;
    const titleKey = `${uid}__title`;

    const hasError = !!item.error;
    const hasChildren = !!children.length && !hasError;

    const itemClasses = {
      [CSS.itemChildren]: hasChildren,
      [CSS.itemError]: !!hasError,
      [CSS.itemUpdating]: item.updating && !parent && visibleElements.statusIndicators,
      [CSS.itemInvisible]: _newUI && !item.visible,
      [CSS.itemInvisibleAtScale]: !item.visibleAtCurrentScale || xtnInvisible, /* Indoors */
      [CSS.itemSelectable]: selectionEnabled
    };

    if (selectionEnabled) {
      const itemProps = {
        [SORT_DATA_ATTR]: item.layer.uid,
        [SORT_FILTER_DATA_ATTR]: (!item.sortable).toString()
      };

      return (
        <li
          key={`item-with-selection-${item.uid}`}
          bind={this}
          // @ts-ignore a
          afterCreate={this._focusListItem} afterUpdate={this._focusListItem}
          class={this.classes(CSS.item, itemClasses)}
          aria-labelledby={titleKey}
          // @ts-ignore b
          onclick={this._toggleSelection} onkeydown={this._selectionKeydown}
          data-item={item}
          data-group={parent ? parent.uid : SORTABLE_ROOT}
          tabIndex={0}
          aria-selected={findSelectedItem(item, selectedItems) ? "true" : "false"}
          role="option"
          {...itemProps}
        >
          {/*
          // @ts-ignore */}
          {this.renderItemContent(item, parent, titleKey)}
        </li>
      );
    }

    return (
      <li
        key={`item-no-selection-${item.uid}`}
        bind={this}
        // @ts-ignore d
        afterCreate={this._focusListItem}
        // @ts-ignore e
        afterUpdate={this._focusListItem}
        class={this.classes(CSS.item, itemClasses)}
        aria-labelledby={titleKey}
      >
        {/*
        // @ts-ignore */}
        {this.renderItemContent(item, parent, titleKey)}
      </li>
    );
  }

}
